import { render, staticRenderFns } from "./PedidoModal.vue?vue&type=template&id=428399f6&scoped=true"
import script from "./PedidoModal.vue?vue&type=script&lang=js"
export * from "./PedidoModal.vue?vue&type=script&lang=js"
import style0 from "./PedidoModal.vue?vue&type=style&index=0&id=428399f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428399f6",
  null
  
)

export default component.exports